import { Card, CardContent, CardHeader } from "@mui/material";
import {
  NumberInput,
  required,
  SimpleForm,
  TextInput,
  useTranslate,
} from "react-admin";
import React from "react";

const headerStyle = {
  backgroundColor: "#2196f3", // Default blue color of React Admin
  color: "white",
  padding: "8px 16px",
  fontWeight: "bold",
};

const RulesForm: React.FC = () => {
  const translate = useTranslate();

  return (
    <SimpleForm mode="onSubmit" reValidateMode="onSubmit">
      {/* Rule Details Section */}
      <Card style={{ marginBottom: "1.5rem", width: "100%" }}>
        <CardHeader
          title={translate("rules.fields.titles.ruleDetails")}
          style={headerStyle}
        />
        <CardContent>
          <TextInput
            source="name"
            label={translate("rules.fields.name.label")}
            validate={required()}
            fullWidth
            helperText={translate("rules.fields.name.helper")}
          />

          <NumberInput
            source="rate"
            label={translate("rules.fields.rate.label")}
            validate={required()}
            min={0}
            max={100}
            helperText={translate("rules.fields.rate.helper")}
            fullWidth
          />
          <TextInput
            source="currencyCode"
            label={translate("rules.fields.currencyCode.label")}
            fullWidth
            helperText={translate("rules.fields.currencyCode.helper")}
          />

          <NumberInput
            source="threshold"
            required={false}
            label={translate("rules.fields.threshold.label")}
            min={0}
            helperText={translate("rules.fields.threshold.helper")}
            fullWidth
          />
        </CardContent>
      </Card>

      {/* Countries Section */}
      <Card style={{ marginBottom: "1.5rem", width: "100%" }}>
        <CardHeader
          title={translate("rules.fields.titles.countries")}
          style={headerStyle}
        />
        <CardContent>
          <TextInput
            source="countriesFrom"
            label={translate("rules.fields.countriesFrom.label")}
            validate={required()}
            fullWidth
            helperText={translate("rules.fields.countriesFrom.helper")}
          />

          <TextInput
            source="countriesTo"
            label={translate("rules.fields.countriesTo.label")}
            validate={required()}
            fullWidth
            helperText={translate("rules.fields.countriesTo.helper")}
          />
        </CardContent>
        <Card style={{width: "100%", padding: "0.5rem"}}>
          <CardHeader
            title={translate("rules.fields.titles.statesTo")}
            style={headerStyle}
          />
          <CardContent>
            <TextInput
              required={false}
              source="statesTo"
              label={translate("rules.fields.statesTo.label")}
              fullWidth
              helperText={translate("rules.fields.statesTo.helper")}
            />
          </CardContent>
        </Card>
      </Card>

      {/* Sellers Section */}
      <Card style={{ width: "100%", marginBottom: "1.5rem",  }}>
        <CardHeader
          title={translate("rules.fields.titles.sellers")}
          style={headerStyle}
        />
        <CardContent>
          <TextInput
            source="sellersLabel"
            label={translate("rules.fields.sellersLabel.label")}
            validate={required()}
            fullWidth
            helperText={translate("rules.fields.sellersLabel.helper")}
          />
        </CardContent>
      </Card>

      <Card style={{ width: "100%" }}>
        <CardHeader
          title={translate("rules.fields.titles.madeInCountries")}
          style={headerStyle}
        />
        <CardContent>
          <TextInput
            required={false}
            source="madeInCountries"
            label={translate("rules.fields.madeInCountries.label")}
            fullWidth
            helperText={translate("rules.fields.madeInCountries.helper")}
          />
        </CardContent>
      </Card>
    </SimpleForm>
  );
};

export default RulesForm;
